import _xor from 'lodash/xor';

const areEqualSets = (listA?: string[], listB?: string[]): boolean => {
  if (!listA || !listB) return false;
  return _xor(listA, listB).length === 0;
};

export { areEqualSets };
